<!-- <Tooltip :text="data?.itemType" length="8" /> -->
<template>
  <a-tooltip :title="text">
    <p class="cursor-pointer">
      {{ text ? trimText(text, length) : "N/A" }}
    </p>
  </a-tooltip>
</template>

<script>
import { trimText } from "@/core/helpers/utility";
export default {
  name: "tooltip",
  data() {
    return {
      trimText,
    };
  },
  props: {
    text: {
      type: String,
      required: true,
      default: "N/A",
    },
    length: {
      type: [Number, String],
      required: true,
      default: 8,
    },
  },
};
</script>
